<template>
  <div class="modal fade" id="addEditUnitModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Unit</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <transition name="slide-fade" mode="out-in">
            <form
              v-if="!newScoreTemplate && page == 1"
              @submit.prevent="page = 2"
            >
              <div class="form-group">
                <label v-if="Subject != null"
                  ><strong>{{ Subject.Title }}</strong></label
                >
              </div>
              <div class="form-group">
                <label for="addUnitName">Unit Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="addUnitName"
                  placeholder="Unit Name"
                  v-model="newUnitName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="addUnitDescription">Unit Description</label>
                <input
                  type="text"
                  class="form-control"
                  id="addUnitDescription"
                  placeholder="Unit Description"
                  v-model="newUnitDescription"
                />
              </div>
              <div
                v-if="Subject != null && ScoreTemplates != null"
                class="form-group"
              >
                <label for="scoreTemplate">Unit Score Template</label>
                <button
                  type="button"
                  class="btn btn-sm btn-link d-inline ml-2 pb-1"
                  v-on:click="newScoreTemplate = true"
                >
                  Create New Score Template
                </button>
                <select
                  id="scoreTemplate"
                  name="scoreTemplatePicker"
                  class="selectpicker d-block"
                  data-style="btn-outline-primary"
                  data-none-selected-text="Select Score Template"
                  data-actions-box="true"
                  data-selected-text-format="count"
                  v-model="selectedScoreTemplate"
                >
                  <option
                    v-for="template in ScoreTemplates"
                    :key="template.Score_Template_Id"
                    v-bind:value="template"
                  >
                    {{ template.Title }}
                  </option>
                </select>
              </div>
              <div class="text-left ml-2" v-if="selectedScoreTemplate != null">
                <div
                  v-for="input in selectedScoreTemplate.Score_Template_Inputs.slice().sort(
                    $orderByOrder
                  )"
                  :key="input.Score_Template_Input_Id"
                >
                  <label class="mb-0"
                    >{{ input.Order }}) {{ input.Request }}</label
                  >
                  <label class="ml-2"
                    ><small
                      >({{ $getScoreTemplateInputSummary(input) }})</small
                    ></label
                  >
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </form>
            <form
              v-if="!newScoreTemplate && page == 2"
              @submit.prevent="submitUnit"
            >
              <div class="form-group">
                <label v-if="Subject != null"
                  ><strong>Add Students to {{ newUnitName }}</strong></label
                >
              </div>
              <div
                v-for="student in availableStudents.slice().sort($orderByName)"
                :key="student.Student_Id + 'manage'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="student.Student_Id + 'manage'"
                  v-bind:value="student"
                  v-model="selectedStudents"
                />
                <label
                  class="form-check-label"
                  v-bind:for="student.Student_Id + 'manage'"
                  >{{ student.Name }} - Grade: {{ student.Grade.Title }}</label
                >
              </div>
              <div class="row">
                <div class="col text-left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage()"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Create Unit
                  </button>
                </div>
              </div>
            </form>
            <ScoreTemplateCreator
              v-if="newScoreTemplate"
              v-bind:Subject="this.Subject"
              v-bind:ScoreTemplateType="1"
              v-bind:OrganizationId="SchoolOrganizationId"
              @cancel-creator="cancelCreator"
              @added-score-template="scoreTemplateAdded"
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ScoreTemplateCreator from "@/components/Score/ScoreTemplateCreator.vue";

export default {
  components: {
    ScoreTemplateCreator
  },
  props: {
    Subject: Object,
    Unit: Object,
    ScoreTemplates: Array,
    Students: Array,
    SchoolOrganizationId: Number
  },
  data() {
    return {
      newUnitName: "",
      newUnitDescription: "",
      newScoreTemplate: false,
      selectedScoreTemplate: null,
      availableStudents: [],
      selectedStudents: [],
      page: 1
    };
  },
  watch: {
    Students: function() {
      this.availableStudents = this.Students.filter(s =>
        s.Subjects.map(su => su.Subject_Id).includes(this.Subject.Subject_Id)
      );
    }
  },
  mounted() {
    $("#addEditUnitModal").on("shown.bs.modal", function() {
      $("#addUnitName").focus();
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#scoreTemplate").length > 0) {
          $(".selectpicker").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    });
  },
  methods: {
    async submitUnit() {
      $("#addEditUnitModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var unitToCreate = {
        Title: view.newUnitName,
        Description: view.newUnitDescription,
        Subject_Id: view.Subject.Subject_Id,
        Score_Template: view.selectedScoreTemplate
      };

      await this.$createUnit(unitToCreate)
        .then(async newUnit => {
          await this.$createUnitStudents(
            newUnit.Unit_Id,
            this.selectedStudents.map(s => s.Student_Id)
          ).then(() => {
            view.$store.commit("updateLoading", false);
            view.$emit("added-unit", this.Subject.Subject_Id);
            this.clearFields();
          });
        })
        .catch(e => {
          console.log(e);
          $("#addEditUnitModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newUnitName = "";
      this.newUnitDescription = "";
      this.newScoreTemplate = false;
      this.selectedScoreTemplate = null;
      this.page = 1;
      this.selectedStudents = [];
    },
    scoreTemplateAdded(scoreTemplate) {
      this.ScoreTemplates.push(scoreTemplate);
      this.selectedScoreTemplate = scoreTemplate;
      this.updatePicker();
      this.newScoreTemplate = false;
    },
    previousPage() {
      switch (this.page) {
        case 2:
          this.page = 1;
          this.updatePicker();
      }
    },
    updatePicker() {
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#scoreTemplate").length > 0) {
          $("#scoreTemplate").selectpicker("val", this.selectedScoreTemplate);
          $(".selectpicker").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    },
    cancelCreator() {
      this.newScoreTemplate = false;
      this.updatePicker();
    }
  }
};
</script>
